import React, { useState } from 'react';
import './Header.css';
import SettingsPanel from './SettingsPanel';

const Header = ({ userProfile, welcomeMessage, onResetProfile, onUpdateProfile }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleReset = () => {
    if (window.confirm('Are you sure you want to reset your profile? This will delete all your progress.')) {
      onResetProfile();
    }
    setShowMenu(false);
  };

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left">
          <h1 className="app-title">Pretty Habits</h1>
          <span className="app-subtitle">✨ Skincare Tracker</span>
        </div>
        
        <div className="header-right">
          <button className="profile-button" onClick={toggleMenu}>
            <span className="profile-initial">
              {userProfile.name.charAt(0).toUpperCase()}
            </span>
          </button>
          
          {showMenu && (
            <div className="profile-menu">
              <div className="profile-info">
                <h3>{userProfile.name}</h3>
                <p>{userProfile.skinType} skin • {userProfile.ageRange}</p>
              </div>
              <button className="menu-item" onClick={() => { setShowSettings(true); setShowMenu(false); }}>
                Settings
              </button>
              <button className="menu-item" onClick={handleReset}>
                Reset Profile
              </button>
            </div>
          )}
        </div>
      </div>
      
      {welcomeMessage && (
        <div className="welcome-banner">
          <h2>{welcomeMessage.greeting}</h2>
          <p>{welcomeMessage.skinTypeMessage} {welcomeMessage.ageMessage}</p>
          <p className="encouragement">{welcomeMessage.encouragement}</p>
        </div>
      )}

      <SettingsPanel
        isOpen={showSettings}
        onClose={() => setShowSettings(false)}
        userProfile={userProfile}
        onUpdateProfile={onUpdateProfile}
      />
    </header>
  );
};

export default Header;
